import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../redux/ApplicationState";
import {
  DocumentReviewPayload,
  MaxAllowedSocDatePayload,
  ReferralDetail,
  UpdateStartOfCareDatePayload,
} from "../../../models/Referral";
import {
  documentDownload,
  getReferralAuthHistory,
  postUpdateStartOfCareDate,
  postDocumentReview,
  getMaxAllowedSocDate,
  postAuthNotifications,
  getAuthNotificationsDownload,
} from "../../../actions/ReferralAction";
import AuthorizationDetails from "../components/AuthorizationDetails";
import { setDefaultInfoForReAuth } from "../../../actions/Patient";
import { UserPageTrack } from "../../../models/User";
import { postUserPageTrack } from "../../../actions/UserAction";
import { resetStates } from "../../../actions/Common";

const mapStateToProps = ({
  referralAuthHistoryState,
  documentReviewState,
  documentDownloadState,
  authNotificationsDownloadState,
  authNotificationsListState,
  updateStartOfCareDateState,
  maxAllowedSocDateState,
}: ApplicationState) => ({
  referralAuthHistory:
  referralAuthHistoryState.response,
  documentReviewListData: documentReviewState.response,
  documentReviewListDataLoading: documentReviewState.loading,
  documentDownloadData: documentDownloadState,
  authNotificationsDownloadData: authNotificationsDownloadState,
  authNotificationsListState,
  updateStartOfCareDateState,
  maxAllowedSocDateState: maxAllowedSocDateState.response,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    getReferralAuthHistory: (referralId: number) => {
      dispatch(getReferralAuthHistory(referralId));
    },
    setDefaultInfoForReAuth: (payload: ReferralDetail) => {
      dispatch(setDefaultInfoForReAuth(payload));
    },
    postDocumentReview: (payload: DocumentReviewPayload) => {
      dispatch(postDocumentReview(payload));
    },
    documentDownload: (blobId: number) => {
      dispatch(documentDownload(blobId));
    },
    postUserPageTrack: (payload: UserPageTrack) => {
      dispatch(postUserPageTrack(payload));
    },
    updateSoC: (payload: UpdateStartOfCareDatePayload) => {
      dispatch(postUpdateStartOfCareDate(payload));
    },
    resetStates: (actionType: string) => {
      dispatch(resetStates(actionType));
    },
    getMaxAllowedSocDate: (payload: MaxAllowedSocDatePayload) => {
      dispatch(getMaxAllowedSocDate(payload));
    },
    postAuthNotifications: (referralId: number) => {
      dispatch(postAuthNotifications(referralId));
    },
    authNotificationsDownload: (blobId: number) => {
      dispatch(getAuthNotificationsDownload(blobId));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthorizationDetails);
